import router from './basic.router'

export default {
  router,
}
